import { Route, Routes, useLocation } from 'react-router-dom'
import { Home } from '../pages/Home'
import { Story } from '../pages/Story'
import { Characters } from '../pages/characters/Characters'
import { System } from '../pages/system/System'
import { Products } from '../pages/Products'
import { Media } from '../pages/Media'
import { Contest } from '../pages/Contest/Contest'
import { ContestPutty } from '../pages/Contest/ContestPutty'
import { ContestRetweet } from '../pages/Contest/ContestRetweet'
import { DLC } from '../pages/DLC'

export const AnimatedRoutes = () => {
    const location = useLocation()
    return (
        <Routes location={location} key={location.pathname}>
            <Route exact path='/' element={<Home />} />
            <Route path='story' element={<Story />} />
            <Route path='characters' element={<Characters />} />
            <Route path='system' element={<System />} />
            <Route path='products' element={<Products />} />
            <Route path='media' element={<Media />} />
            <Route path='contest' element={<Contest />} /> <Route path='dlc' element={<DLC />} />{' '}
            <Route path='/contest/retweet-contest' element={<ContestRetweet />} />{' '}
            <Route path='/contest/putty-contest' element={<ContestPutty />} />
        </Routes>
    )
}
